import { useStore } from 'features/ListBuilder/infra/react/ListBuilderStore/useStore'

export const useUpdateListNameState = () =>
  useStore(store => store.updateListName.state)
